module.exports = __webpack_public_path__ + "static/media/conference_35.9f259233.jpg";